<template>
  <div
    class="footer-subfooter-container"
    :class="[schema.settings.backgroundColor, schema.settings.borderColor]"
  >
    <div class="footer-subfooter" :class="[schema.settings.textColor]">
      <div class="footer-subfooter__menu" v-if="schema.settings.subfooterMenu.links.length > 0">
        <div
          class="footer-subfooter__link-container body-sm-mobile body-md-tablet-up"
          v-for="link in schema.settings.subfooterMenu.links"
          :key="link.id"
        >
          <a class="footer-subfooter__link body-sm" :href="link.url">
            <span class="link__content">{{ link.title }}</span>
          </a>
        </div>
      </div>
      <div
        class="footer-subfooter__copyright body-sm color-grey"
      >{{ schema.settings.copyrightText }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterSubFooter',
  components: {},
  props: {
    schema: Object,
  },
  methods: {},
  data() {
    return {};
  },
};
</script>

<style lang="scss">
.footer-subfooter-container {
  padding: 16px;

  @include tablet-up {
    padding: 24px 20px;
  }
}

.footer-subfooter {
  max-width: #{$container-max-width - 40px};
  margin: 0 auto;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  @include tablet-up {
    justify-content: center;
    flex-direction: row;
  }

  &__menu {
    display: flex;
    flex-wrap: wrap;

    @include mobile-only {
      order: 1;
      justify-content: center;
      align-items: center;
      text-align: center;
    }

    &:not(:last-child) {
      @include tablet-up {
        margin-left: -12px;
      }
    }

    .footer-content--center & {
      @include mobile-only {
        justify-content: center;
      }
    }
  }

  &__link-container {
    margin-bottom: 16px;
    flex-basis: 50%;
    flex-grow: 1;

    @include mobile-only {
      padding: 0 6px;
      flex: 0 1 auto;
    }

    @include tablet-up {
      margin: 0 12px;
      line-height: 1.15;
      flex-basis: auto;
      flex-grow: 0;
    }

    &:nth-child(even) {
      padding-left: 20px;

      @include mobile-only {
        padding: 0 6px;
      }

      @include tablet-up {
        padding-left: 0;
      }
    }

    &:nth-child(odd) {
      padding-right: 20px;

      @include mobile-only {
        padding: 0 6px;
      }

      @include tablet-up {
        padding-right: 0;
      }

      &:last-child {
        padding-right: 0;
      }
    }
  }

  &__link {
    display: block;
    text-decoration: underline;
    color: $color-grey;

    &:hover {
      color: $color-white;
    }

    .link__content {
      font-size: inherit;
      line-height: inherit;
    }

    .footer-content--center & {
      @include mobile-only {
        margin: 0 auto;
      }
    }
  }

  &__copyright {
    &:not(:nth-child(1)) {
      @include tablet-up {
        margin-left: 12px;
      }
    }

    @include mobile-only {
      text-align: center;
      margin-bottom: 4px;
    }

    .footer-content--center & {
      @include mobile-only {
        text-align: center;
      }
    }
  }
}
</style>
